import React, { useEffect } from 'react';
import { Box } from '../Box';
import { IO } from '../IO';

export const Video = ({
    video,
    videoId,
    videoPoster,
    autoPlay = true,
    isIO = false,
    ...props
}) => {
    useEffect(() => {
        try {
            if (autoPlay && isIO && document) {
                document.getElementById(videoId).play();
            } else if (isIO && !autoPlay && document) {
                document.getElementById(videoId).pause();
            }
        } catch (e) {
            //
        }
    }, [autoPlay, isIO]);

    return (
        <Box
            as="video"
            rounded="radius"
            overflow="hidden"
            onClick={e => {
                document.getElementById(videoId).play();
            }}
            muted
            autoPlay={autoPlay}
            id={videoId}
            playsInline
            poster={videoPoster}
            loop
            {...props}
        >
            <source src={video} type="video/mp4" />
        </Box>
    );
};

export const AutoplayWhenVisibleVideo = props => {
    return (
        <IO rootMargin="100px" key={`video_autoplay_${props.videoId}`}>
            {({ isVisible }) => <Video isIO {...props} autoPlay={isVisible} />}
        </IO>
    );
};
